<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a Weekly Room Reward
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.weekly_room_target"
                outlined
                label="Weekly Room Target *"
                prepend-inner-icon="mdi-target"
                type="number"
                min="1"
                :error-messages="errors.weekly_room_target"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.weekly_reward"
                outlined
                label="Weekly Reward *"
                prepend-inner-icon="mdi-bitcoin"
                type="number"
                min="1"
                :error-messages="errors.weekly_reward"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.frame"
                outlined
                label="Frame"
                prepend-inner-icon="mdi-image-frame"
                :error-messages="errors.frame"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.medal"
                outlined
                label="Medal"
                prepend-inner-icon="mdi-medal"
                :error-messages="errors.medal"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                v-model="form.is_active"
                label="Is Active"
                color="primary"
                inset
              ></v-switch>
            </v-col>
          </v-row>

          <!-- Preview Section -->
          <v-divider class="mt-5 mb-5"></v-divider>
          <v-row v-if="form.weekly_room_target">
            <v-col sm="12">
              <h4 class="mb-3">Reward Preview</h4>
              <v-card outlined>
                <v-card-text>
                  <v-row>
                    <v-col sm="3">
                      <strong>Target:</strong> {{ formatNumber(form.weekly_room_target) }} rooms
                    </v-col>
                    <v-col sm="3">
                      <strong>Reward:</strong> {{ formatNumber(form.weekly_reward) }} coins
                    </v-col>
                    <v-col sm="3">
                      <strong>Tier:</strong>
                      <v-chip
                        small
                        :color="getTierColor(form.weekly_room_target)"
                        text-color="white"
                      >
                        {{ getRewardTier(form.weekly_room_target) }}
                      </v-chip>
                    </v-col>
                    <v-col sm="3">
                      <strong>Status:</strong>
                      <v-chip
                        small
                        :color="form.is_active ? 'teal' : 'red'"
                        text-color="white"
                      >
                        {{ form.is_active ? 'Active' : 'Inactive' }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-5"></v-divider>

          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Weekly Room Reward
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "WeeklyRoomRewardCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        weekly_room_target: null,
        weekly_reward: null,
        frame: "",
        medal: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async save() {
      this.isLoading = true;

      try {
        let response = await axios.post("/weekly_room_rewards", this.form);

        if (response.data.success) {
          this.$store.dispatch("snackBar", {
            color: "success",
            message: "Weekly Room Reward created successfully",
          });
          this.$router.push("/weekly_room_rewards");
        } else {
          this.$store.dispatch("snackBar", {
            color: "error",
            message: response.data.message || "Failed to create weekly room reward",
          });
        }
      } catch (error) {
        console.error("Error creating weekly room reward:", error);

        this.$store.dispatch("snackBar", {
          color: "error",
          message: error.response?.data?.message || "Failed to create weekly room reward",
        });
      } finally {
        this.isLoading = false;
      }
    },

    formatNumber(value) {
      if (!value) return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getRewardTier(target) {
      const targetValue = parseInt(target) || 0;

      if (targetValue >= 2000) return 'Legendary';
      if (targetValue >= 1500) return 'Epic';
      if (targetValue >= 1000) return 'Diamond';
      if (targetValue >= 500) return 'Platinum';
      if (targetValue >= 200) return 'Gold';
      if (targetValue >= 100) return 'Silver';
      if (targetValue >= 50) return 'Bronze';
      return 'Starter';
    },

    getTierColor(target) {
      const tier = this.getRewardTier(target);
      const colorMap = {
        'Legendary': 'purple',
        'Epic': 'deep-purple',
        'Diamond': 'blue',
        'Platinum': 'cyan',
        'Gold': 'amber',
        'Silver': 'grey',
        'Bronze': 'brown',
        'Starter': 'green'
      };
      return colorMap[tier] || 'grey';
    },
  },
};
</script>

<style scoped>
.v-text-field >>> .v-input__control .v-input__slot {
  min-height: 56px;
}
</style>